
import { mapState } from 'vuex';
import fileUploadService from '~/services/fileUpload';
import formMixin from '~/services/form';
import { contactDetails, price, required } from '~/services/validators';

export default {
    name: 'SiteCommentsForm',
    mixins: [formMixin],
    props: {
        /**
         * A blog post id
         */
        blog: {
            type: Number,
            default: null,
        },
        /**
         * Should we be able to attach images to comments
         */
        canAttachImages: {
            type: Boolean,
            default: false,
        },
        /**
         * Should we filter contact details on submission?
         */
        filterContactDetails: {
            type: Boolean,
            default: false,
        },
        /**
         * Is theis a comment form on job page
         */
        isJobComment: {
            type: Boolean,
            default: false,
        },
        /**
         * A fly-tipping report id
         */
        report: {
            type: Number,
            default: null,
        },
        /**
         * An api endpoint to send comments to
         */
        url: {
            type: String,
            required: true,
        },
        /**
         * Is this a reply?
         */
        isReply: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            content: '',
            images: [],
        };
    },
    computed: {
        ...mapState(['auth']),
        placeholder() {
            if (this.isReply) {
                return this.$t('comments.write_reply');
            }
            return this.$t('comments.write_comment');
        },
    },
    watch: {
        filterContactDetails(val) {
            if (!val) {
                this.$form.replaceValidations(this.$options.validations);
            }
        },
    },
    created() {
        const contentValidations = this.$options.validations.content;
        if (this.filterContactDetails) {
            contentValidations.push(contactDetails);
        }
        if (this.isJobComment) {
            contentValidations.push({ validator: price, message: 'error_messages.comment_price' });
        }
        this.$form.replaceValidations(this.$options.validations);
    },
    mounted() {
        if (this.isReply) {
            this.$refs.textinput.focus();
        }
    },
    methods: {
        async submit() {
            this.$form.$submitted = true;
            if (this.$form.validate()) {
                this.$clearwaste.$loading.start();
                this.$form.$submitting = true;
                const images = await fileUploadService(this.images, this.$axios, this.$config, this.$sentry);
                const { comment } = await this.$form.submit(this.url, '$post', {
                    ...(this.images.length && { images: images.map((image) => image.id) }),
                    blog_id: this.blog,
                    content: this.content,
                    report_id: this.report,
                });
                this.$form.content.$model = '';
                this.$form.images.$model = [];
                if (this.$refs.upload) {
                    this.$refs.upload.reset();
                }
                this.$form.reset();
                /**
                 * Add a comment
                 *
                 * @type {object}
                 */
                this.$emit('add', comment);
            }
        },
    },
    validations: {
        content: [{ validator: required, message: 'error_messages.comment' }],
        images: [],
    },
};
